module.exports = "<select (change)=\"changeLang($event.target.value)\" [(ngModel)]=\"departamentoSelected\">\n  <option [value]=\"item.id\" *ngFor=\"let item of departamento\">\n    {{ item.nombre }} \n  </option>\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/control-core/shared/select-departamentos/select-departamentos.component.html
// module id = ./src/app/control-core/shared/select-departamentos/select-departamentos.component.html
// module chunks = main